import { render, staticRenderFns } from "./QuantityInput.vue?vue&type=template&id=254c844a&scoped=true"
import script from "./QuantityInput.vue?vue&type=script&lang=ts"
export * from "./QuantityInput.vue?vue&type=script&lang=ts"
import style0 from "./QuantityInput.vue?vue&type=style&index=0&id=254c844a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "254c844a",
  null
  
)

export default component.exports